/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Ansteuerinfos2Inputs */



/**

* @param {_Field_Ansteuerinfos2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_ansteuerinfos2 = /** @type {((inputs?: _Field_Ansteuerinfos2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Ansteuerinfos2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Steuerinformationen")
});
export { _field_ansteuerinfos2 as "_field_anSteuerInfos" }